import {ScheduledTaskTrigger} from "../scheduled_task_trigger/scheduledTaskTrigger";
import './shcedule_component.scss';

export class ScheduledTaskComponent {

    constructor($scope, $mdToast, SchedulesService, $mdDialog, TRIGGER_TYPES, STRATEGIES_ENUM) {
        $scope.updateTask = this.updateTask.bind(this);
        $scope.showDialogFor = this.showDialogFor.bind(this);
        $scope.createTrigger = this.createTrigger.bind(this);
        $scope.openMenu = this.openMenu.bind(this);
        $scope.deleteTrigger = this.deleteTrigger.bind(this);
        $scope.editTrigger = this.editTrigger.bind(this);
        $scope.executeNow = this.executeNow;
        this.$mdToast = $mdToast;
        this.STRATEGIES_ENUM = STRATEGIES_ENUM;
        this.TRIGGER_TYPES = TRIGGER_TYPES;
        this.$mdDialog = $mdDialog;
        this.$scope = $scope;
        this.SchedulesService = SchedulesService;
    }

    $onInit() {
        let schedule = this.schedule;
        schedule.displayName = schedule.displayName ? schedule.displayName : schedule.name;
        this.$scope.schedule = schedule;
    }

    openMenu($mdMenu, ev) {
        this.originatorEv = ev;
        $mdMenu.open(ev);
    };

    executeNow = ($event, schedule) => {
        this.$mdDialog.show(
            this.$mdDialog.confirm()
                .title(`Are you sure you want to execute the schedule \'${schedule.displayName}?\'`)
                .textContent('The selected scheduled task is going to be executed immediately.')
                .ariaLabel('Execute schedule now')
                .targetEvent($event)
                .ok('Yes, do it!')
                .cancel('No, I changed my mind')
        ).then(() => {
            this.SchedulesService.executeNow(schedule.id);
        }, () => {

        })
    };

    editTrigger(trigger, event) {
        this.showDialogFor(trigger, event).then(
            (editedTrigger) => {
                let index = this.$scope.schedule.triggers.findIndex((t) => t.id === editedTrigger.id);
                this.$scope.schedule.triggers[index] = editedTrigger;
            }, (originalTrigger) => {

            });
    }

    createTrigger(event) {
        let trigger = {
            strategy: this.STRATEGIES_ENUM.RUN_INDEFINITELY.value,
            taskType: this.TRIGGER_TYPES.CRON_JOB.value,
            active: true,
            zoneId: 'America/Chicago'
        };
        this.showDialogFor(trigger, event).then(
            (newTrigger) => {
                this.$scope.schedule.triggers.push(newTrigger)
            }, () => {
                this.$scope.status = 'You cancelled the dialog.';
            });
    }

    deleteTrigger(trigger) {
        this.deleteTrigger = this.SchedulesService.deleteTrigger(this.schedule.id, trigger.id)
            .then(resp => {
                if (resp.status === 200) {
                    this.$scope.schedule.triggers = this.schedule.triggers.filter((t) => t.id !== trigger.id);
                }
            });
    }

    updateTask() {
        // this.schedule.runUntil = "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'"
        this.SchedulesService.saveSchedule(this.schedule)
            .then((resp) => {
                    this.$mdToast.show(
                        this.$mdToast.simple()
                            .textContent('Task updated!')
                            .hideDelay(3000)
                    )
                }
            );
    }


    showDialogFor(trigger, ev) {
        let dialogElement = ScheduledTaskTrigger.getInstance(ev, trigger, this.$scope.schedule);
        return this.$mdDialog.show(dialogElement);
    }

}
